// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Kontent$PrezzeeRibbon from "../../personal/Kontent/Kontent.bs.js";
import * as ThemeContext$PrezzeeRibbon from "../../../context/ThemeContext/ThemeContext.bs.js";
import * as Theme__Typography$PrezzeeRibbon from "../../../theme/Theme__Typography.bs.js";
import * as Footer__Responsive$PrezzeeRibbon from "./Footer__Responsive.bs.js";

function footerBlock(theme) {
  var match = theme.components;
  var footer = match.footer;
  return BsCssJs$PrezzeeRibbon.merge([
              Theme__Typography$PrezzeeRibbon.Styles.style5,
              BsCssJs$PrezzeeRibbon.style([
                    BsCssJs$PrezzeeRibbon.backgroundColor(footer.backgroundColor),
                    BsCssJs$PrezzeeRibbon.color(footer.color),
                    BsCssJs$PrezzeeRibbon.media(Footer__Responsive$PrezzeeRibbon.desktop, [
                          BsCssJs$PrezzeeRibbon.paddingTop(BsCssJs$PrezzeeRibbon.px(22)),
                          BsCssJs$PrezzeeRibbon.paddingBottom(BsCssJs$PrezzeeRibbon.px(13))
                        ]),
                    BsCssJs$PrezzeeRibbon.media(Footer__Responsive$PrezzeeRibbon.tablet, [
                          BsCssJs$PrezzeeRibbon.paddingTop(BsCssJs$PrezzeeRibbon.px(36)),
                          BsCssJs$PrezzeeRibbon.paddingBottom(BsCssJs$PrezzeeRibbon.px(36))
                        ]),
                    BsCssJs$PrezzeeRibbon.media(Footer__Responsive$PrezzeeRibbon.mobile, [
                          BsCssJs$PrezzeeRibbon.paddingTop(BsCssJs$PrezzeeRibbon.px(16)),
                          BsCssJs$PrezzeeRibbon.paddingBottom(BsCssJs$PrezzeeRibbon.px(16))
                        ])
                  ])
            ]);
}

var footerGrid = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.display("grid"),
      BsCssJs$PrezzeeRibbon.media(Footer__Responsive$PrezzeeRibbon.desktop, [BsCssJs$PrezzeeRibbon.gridTemplateColumns([{
                    NAME: "repeat",
                    VAL: [
                      {
                        NAME: "num",
                        VAL: 5
                      },
                      BsCssJs$PrezzeeRibbon.fr(1)
                    ]
                  }])]),
      BsCssJs$PrezzeeRibbon.media(Footer__Responsive$PrezzeeRibbon.tablet, [BsCssJs$PrezzeeRibbon.gridTemplateColumns([
                  {
                    NAME: "minmax",
                    VAL: [
                      BsCssJs$PrezzeeRibbon.px(200),
                      BsCssJs$PrezzeeRibbon.fr(1)
                    ]
                  },
                  {
                    NAME: "minmax",
                    VAL: [
                      BsCssJs$PrezzeeRibbon.px(200),
                      BsCssJs$PrezzeeRibbon.fr(1)
                    ]
                  },
                  {
                    NAME: "minmax",
                    VAL: [
                      BsCssJs$PrezzeeRibbon.px(200),
                      BsCssJs$PrezzeeRibbon.fr(1)
                    ]
                  },
                  BsCssJs$PrezzeeRibbon.fr(1)
                ])]),
      BsCssJs$PrezzeeRibbon.media(Footer__Responsive$PrezzeeRibbon.mobile, [BsCssJs$PrezzeeRibbon.gridTemplateColumns([{
                    NAME: "repeat",
                    VAL: [
                      {
                        NAME: "num",
                        VAL: 1
                      },
                      BsCssJs$PrezzeeRibbon.fr(1)
                    ]
                  }])])
    ]);

var Styles = {
  footerBlock: footerBlock,
  footerGrid: footerGrid
};

function Footer(props) {
  var outerClassName = props.outerClassName;
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  var outerClassName$1 = outerClassName !== undefined ? outerClassName : "";
  var theme = ThemeContext$PrezzeeRibbon.useTheme(undefined);
  return JsxRuntime.jsx(Kontent$PrezzeeRibbon.Consumer.make, {
              children: JsxRuntime.jsx("footer", {
                    children: JsxRuntime.jsx("div", {
                          children: props.children,
                          className: Classnames([
                                footerGrid,
                                className$1
                              ])
                        }),
                    className: Classnames([
                          footerBlock(theme),
                          outerClassName$1
                        ])
                  })
            });
}

var SocialIcon;

var Link;

var LinkList;

var Column;

var Heading;

var Copyright;

var Responsive;

var make = Footer;

export {
  Styles ,
  SocialIcon ,
  Link ,
  LinkList ,
  Column ,
  Heading ,
  Copyright ,
  Responsive ,
  make ,
}
/* footerGrid Not a pure module */
